export default () => ({
    init() {
        this.$nextTick(() => {
            const slider = this.$root.querySelector('[data-slider]')

            if (!slider) return

            this.updateBtnState()

            slider.addEventListener('scroll', this.updateBtnState.bind(this))
        })
    },

    updateBtnState() {
        const slider = this.$root.querySelector('[data-slider]')
        const previousBtn = this.$root.querySelector('[data-previous]')
        const nextBtn = this.$root.querySelector('[data-next]')

        if (!slider || !previousBtn || !nextBtn) return

        const scrollLeft = slider.scrollLeft
        const scrollWidth = slider.scrollWidth

        if (scrollLeft === 0) {
            nextBtn.removeAttribute('disabled')
            previousBtn.setAttribute('disabled', true)
        } else if (scrollLeft + slider.clientWidth === scrollWidth) {
            previousBtn.removeAttribute('disabled')
            nextBtn.setAttribute('disabled', true)
        } else {
            previousBtn.removeAttribute('disabled')
            nextBtn.removeAttribute('disabled')
        }
    },
    slide(previous = false) {
        const slider = this.$root.querySelector('[data-slider]')
        const scrollAmount = previous ? -slider.clientWidth : slider.clientWidth

        slider.scrollBy({
            left: scrollAmount,
            behavior: 'smooth',
        })
    },
})
